import React, { useEffect, useState } from "react";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";

import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";

import { useUpdateReworkLogDataMutation } from "./reworkApi";
import MultiSelect from "../../../components/shared/fields/Multiselect";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import useTranslator from "../../../hooks/useTranslator";

const EditReworkLogs = ({ show, setShow, record, mode, activeTab }) => {  
  const { _t } = useTranslator();
  const isViewOnly = record?.status === "moved";
  const [multiSelectData, setMultiSelectData] = useState({});

  const MULTISELECT_KEYS = ["seconds", "humidity", "green", "bone_seed", "toasted", "strange_material", "spot", "tapita", "pieces"];

  const handleMultiSelectChange = (updatedSelectedOptions) => {
    setMultiSelectData(updatedSelectedOptions);

    // Reset all multiselect keys to 0, then apply only selected ones
    const resetKeys = MULTISELECT_KEYS.reduce((acc, key) => {
      acc[key] = 0;
      return acc;
    }, {});

    setFormData((prev) => ({
      ...prev,
      ...resetKeys,
      ...updatedSelectedOptions,
    }));
  };

  const [updateReworkData, { isLoading: isUpdating }] =
    useUpdateReworkLogDataMutation();
  const getType = (type) => {
    if (type === "seconds") return _t("reworklogs_seconds", "Seconds KG");
    if (type === "humidity") return _t("reworklogs_humidity", "Humidity Kg");
    if (type === "green") return _t("reworklogs_green", "Green Kg");
    if (type === "bone_seed") return _t("reworklogs_bone_seed", "Bone/Seed Kg");
    if (type === "toasted") return _t("reworklogs_toasted", "Toasted");
    if (type === "strange_material") return _t("reworklogs_strange_material", "Foreign Material");
    if (type === "tapita") return _t("tapita", "Tapita");
    if (type === "pieces") return _t("pieces", "Pieces");
    return _t("reworklogs_spot", "Spot");
  };
  const initialFormData = {
    created_at: "",
    entity_type: "",
    total_kg: "",
    prime: "",
    strips: "",
    seconds: "",
    humidity: "",
    green: "",
    bone_seed: "",
    toasted: "",
    strange_material: "",
    spot: "",
    tapita: "",
    pieces: "",
    trash: "",
    lot_number: "",
    status: "still_counting",
    selectedOptions: {},
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (mode === "edit" && record) {
      // Build multiSelectData from non-zero multiselect keys in the record
      const prefillMultiSelect = MULTISELECT_KEYS.reduce((acc, key) => {
        if (record[key] && Number(record[key]) !== 0) {
          acc[key] = record[key];
        }
        return acc;
      }, {});

      setMultiSelectData(prefillMultiSelect);

      setFormData({
        ...initialFormData,
        created_at: record.created_at?.split(" ")[0] || "",
        entity_type: record.entity_type || "",
        total_kg: record.total_kg || "",
        lot_number: record.lot_number || "",
        prime: record.prime ?? "",
        strips: record.strips ?? "",
        trash: record.trash ?? "",
        status: record.status || "still_counting",
        ...prefillMultiSelect,
        selectedOptions: {},
      });
    }
  }, [mode, record, show]);
  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (e) => {
    const mutation = updateReworkData;

    // Ensure all multiselect keys default to 0 if not selected
    const normalizedPayload = {
      ...formData,
      ...MULTISELECT_KEYS.reduce((acc, key) => {
        acc[key] = formData[key] !== "" && formData[key] !== undefined ? Number(formData[key]) : 0;
        return acc;
      }, {}),
    };

    try {
      const payload = { id: record.id, requestBody: normalizedPayload };
      await mutation(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <InputWithLabel
          label={_t("reworklogs_date", "Date")}
          type="text"
          name="created_at"
          value={formData.created_at}
          onChange={handleChange}
          placeholder={_t("reworklogs_date_placeholder", "Date...")}
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("reworklogs_lot_number", "Lot Number")}
          type="number"
          name="lot_number"
          value={formData.lot_number}
          onChange={handleChange}
          disabled={true}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("reworklogs_type", "Type")}
          type="text"
          name="entity_type"
          value={getType(formData.entity_type)}
          placeholder={_t("reworklogs_type_placeholder", "Reprocessing...")}
          onChange={handleChange}
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("reworklogs_total_kg", "Total KG")}
          type="number"
          name="total_kg"
          value={formData.total_kg}
          onChange={handleChange}
          disabled={true}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        {record.type === "cheeks" ? (
          <>
            <Row>
              <Col lg={6}>
                <InputWithLabel
                  label={_t("rework_total_prime_kg", "Total Prime KG")}
                  type="number"
                  name="prime"
                  value={formData.prime}
                  onChange={handleChange}
                  placeholder={"0"}
                />
              </Col>
              <Col lg={6}>
                <InputWithLabel
                  label={_t("rework_total_prime_strips", "Total Prime Strips")}
                  type="number"
                  name="strips"
                  value={formData.strips}
                  onChange={handleChange}
                  placeholder={"0"}
                />
              </Col>
            </Row>
          </>
        ) : (
          <Col lg={12}>
            <InputWithLabel
              label={_t("rework_total_prime_kg", "Total Prime KG")}
              type="number"
              name="prime"
              value={formData.prime}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
        )}
      </Col>
      <Col lg={6}>
        <MultiSelect
          options={[ 
            { value: "seconds", label: _t("reworklogs_seconds", "Seconds") },
            { value: "humidity", label: _t("reworklogs_humidity", "Humidity") },
            { value: "green", label: _t("reworklogs_green", "Green KG") },
            { value: "bone_seed", label: _t("reworklogs_bone_seed", "Bone/Seed") },
            { value: "toasted", label: _t("reworklogs_toasted", "Toasted") },
            { value: "strange_material", label: _t("reworklogs_strange_material", "Foreign Material") },
            { value: "spot", label: _t("reworklogs_spot", "Spot") },
            ...(activeTab === "cheeks"
              ? [
                  { value: "tapita", label: _t("tapita", "Tapita") },
                  { value: "pieces", label: _t("pieces", "Pieces") },
                ]
              : activeTab === "strips"
              ? [{ value: "pieces", label: _t("pieces", "Pieces") }]
              : []),
          ]}
          value={formData.selectedOptions || []}
          selectedData={multiSelectData}
          onChange={handleMultiSelectChange}
        />
      </Col>

      <Col lg={6}>
        <InputWithLabel
          label={_t("reworklogs_trash", "Total Rejected")}
          type="number"
          name="trash"
          value={formData.trash}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <SelectBox
          label={_t("status", "Status")}
          name="status"
          value={formData.status}
          onChange={handleChange}
          options={[
            { value: "still_counting", label: _t("still_counting", "Still Counting") },
            { value: "moved", label: _t("moved", "Moved") },
          ]}
        />
      </Col>
    </>
  );
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "editHumidity"
          ? _t("reworklogs_modal_title_humidity", "Adding Humidity Data")
          : `${_t("add_entity_log_data", "Add")}  ${getType(formData.entity_type)} ${_t("log_data", "Log Data")}`
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          {!isViewOnly && (
            <Button
              label={_t("reworklogs_save_changes", "Save Changes")}
              size="small"
              onClick={handleSubmit}
            />
          )}
        </Col>
      </Row>
    </CommonModal>
  );
};

export default EditReworkLogs;
